const {
  makeCard,
  cardSuit,
  cardRank,
  SUIT_MIN,
  SUIT_MAX,
  RANK_9,
  RANK_J,
  RANK_Q,
  RANK_K,
  RANK_10,
  RANK_A,
} = require("../../shared/game/belot/armenian/types");
const { MOLDOVAN_DECLARATION_POINTS } = require("./moldovanConstants");

function runsFromRanks(sortedUniqueRanks) {
  if (!sortedUniqueRanks.length) return [];
  const runs = [];
  let start = 0;
  for (let i = 1; i <= sortedUniqueRanks.length; i += 1) {
    const breaks =
      i === sortedUniqueRanks.length || sortedUniqueRanks[i] !== sortedUniqueRanks[i - 1] + 1;
    if (breaks) {
      const run = sortedUniqueRanks.slice(start, i);
      if (run.length >= 3) runs.push(run);
      start = i;
    }
  }
  return runs;
}

function sequenceMeta(run) {
  if (run.length >= 5) return { label: "CENT", points: MOLDOVAN_DECLARATION_POINTS.cent };
  if (run.length === 4) return { label: "CINQUANTE", points: MOLDOVAN_DECLARATION_POINTS.cinquante };
  return { label: "TERC", points: MOLDOVAN_DECLARATION_POINTS.terc };
}

function detectDeclarations(hand, trumpSuit = null) {
  const byRankCount = new Map();
  const out = [];
  for (const card of hand) {
    const rank = cardRank(card);
    byRankCount.set(rank, (byRankCount.get(rank) || 0) + 1);
  }

  for (const [rank, count] of byRankCount.entries()) {
    if (count !== 4) continue;
    if (rank === RANK_J) out.push({ kind: "CAReU", label: "CAREU_J", points: MOLDOVAN_DECLARATION_POINTS.careuJacks, rank });
    else if (rank === RANK_9) out.push({ kind: "CAReU", label: "CAREU_9", points: MOLDOVAN_DECLARATION_POINTS.careuNines, rank });
    else if (rank === RANK_A || rank === RANK_10 || rank === RANK_K || rank === RANK_Q) {
      out.push({ kind: "CAReU", label: "CAREU_FACE", points: MOLDOVAN_DECLARATION_POINTS.careuFaces, rank });
    }
  }

  for (let suit = SUIT_MIN; suit <= SUIT_MAX; suit += 1) {
    const ranks = hand
      .filter((card) => cardSuit(card) === suit)
      .map((card) => cardRank(card))
      .sort((a, b) => a - b);
    const uniq = [...new Set(ranks)];
    for (const run of runsFromRanks(uniq)) {
      const meta = sequenceMeta(run);
      out.push({
        kind: "SEQUENCE",
        label: meta.label,
        points: meta.points,
        length: run.length,
        highRank: run[run.length - 1],
        suit,
      });
    }
  }

  if (trumpSuit != null) {
    const hasK = hand.includes(makeCard(trumpSuit, RANK_K));
    const hasQ = hand.includes(makeCard(trumpSuit, RANK_Q));
    if (hasK && hasQ) {
      out.push({ kind: "BELLA", label: "BELLA", points: MOLDOVAN_DECLARATION_POINTS.bella });
    }
  }

  return out;
}

function compareSequenceStrength(a, b) {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;
  if (a.length !== b.length) return a.length - b.length;
  return a.highRank - b.highRank;
}

function applySequencePrecedence(teamADeclarations, teamBDeclarations) {
  const aSeq = teamADeclarations.filter((d) => d.kind === "SEQUENCE");
  const bSeq = teamBDeclarations.filter((d) => d.kind === "SEQUENCE");

  const bestA = aSeq.reduce((best, cur) => (compareSequenceStrength(cur, best) > 0 ? cur : best), null);
  const bestB = bSeq.reduce((best, cur) => (compareSequenceStrength(cur, best) > 0 ? cur : best), null);
  const cmp = compareSequenceStrength(bestA, bestB);

  const keepASeq = cmp >= 0 ? aSeq : [];
  const keepBSeq = cmp <= 0 ? bSeq : [];

  const scoreA = teamADeclarations
    .filter((d) => d.kind !== "SEQUENCE")
    .concat(keepASeq)
    .reduce((sum, d) => sum + d.points, 0);
  const scoreB = teamBDeclarations
    .filter((d) => d.kind !== "SEQUENCE")
    .concat(keepBSeq)
    .reduce((sum, d) => sum + d.points, 0);

  return {
    winner: cmp === 0 ? "tie" : cmp > 0 ? "teamA" : "teamB",
    scoreA,
    scoreB,
    keptSequencesA: keepASeq,
    keptSequencesB: keepBSeq,
  };
}

module.exports = {
  detectDeclarations,
  compareSequenceStrength,
  applySequencePrecedence,
};
